import ClientBusinessAndUserView from '../../components/ClientBusinessInfoAndUser/Index'
import {
  connect
} from 'react-redux';
import {
  getClientBusinessTotal,
  clientBusinessSearch,
  getAllSearch,
  usersSearch,
  getAllUsersSearch,
  searchClientsWithKeyword,
  usersSearchAll,
  clearUsersSearch
} from '../../actions/ClientBusinessInfoAndUser';

const mapStateToProps = (state) => {
  const {
    client_business_total,
    search_results,
    all_search_results,
    client_users_total,
    users_results,
    all_users_results
  } = state.clientBusinessAndUser
  const {token} = state.app
  return {
    client_business_total,
    client_users_total,
    search_results,
    all_search_results,
    users_results,
    all_users_results,
    clients: state.app.clients,
    token
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getClientBusinessTotal: () => {
      dispatch(getClientBusinessTotal())
    },
    clientBusinessSearch: (obj) => {
      dispatch(clientBusinessSearch(obj))
    },
    getAllSearch: (obj) => {
      dispatch(getAllSearch(obj))
    },
    usersSearch: (obj) => {
      dispatch(usersSearch(obj))
    },
    usersAll: () => {
      dispatch(usersSearchAll({
        clientId: '',
        pageNumber: 1,
        pageSize: 500,
        sortColumn: 'clientName',
        order: 'asc'
      }))
    },
    getAllUsersSearch: (obj) => {
      dispatch(getAllUsersSearch(obj))
    },
    clearUsersSearch: () => {
      dispatch(clearUsersSearch())
    },
    searchClientsWithKeyword: (keyword) => {
      dispatch(searchClientsWithKeyword(keyword))
    }
  }
}

const ClientBusinessAndUser = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientBusinessAndUserView)

export default ClientBusinessAndUser


// WEBPACK FOOTER //
// ./src/containers/ClientBusinessInfoAndUser/ClientBusinessInfoAndUser.js